
import { call, put, takeEvery } from 'redux-saga/effects'

import {
    clearActionType,
    createActionTypes,
    setOperationError
} from '../common/client/sagas/common';

import getPromiseCallback from '../common/client/utils/getPromiseCallback';

export const PROJECT_ACTION_TYPE = createActionTypes('project/BASE');
export const ADD_USEK = 'project/ADD_USEK';
export const ADD_OPERATION_ITEM = 'project/ADD_OPERATION_ITEM';
export const CLEAR = 'project/CLEAR';
export const CLEAR_READ_FILE = 'project/CLEAR_READ_FILE';
export const CHANGE_USEK_ID = 'project/CHANGE_USEK_ID';
export const DELETE_OPERATION_ITEM = 'project/DELETE_OPERATION_ITEM';
export const DELETE_USEK = 'project/DELETE_USEK';
export const EDIT_USEK = 'project/EDIT_USEK';
export const READ_PRICELIST = 'project/READ_PRICELIST';
export const READ_PROJECT = 'project/READ_PROJECT';
export const READ_FILE = 'project/READ_FILE';
export const SET_CALCULATION_OPERATION = 'project/SET_CALCULATION_OPERATION';
export const SET_ERROR_MESSAGE = 'project/SET_ERROR_MESSAGE';
export const SET_INPUT_TYPE = 'project/SET_INPUT_TYPE';
export const SET_MAP_CONTENT = 'project/SET_MAP_CONTENT';
export const SET_PRICELIST_TYPE = 'project/SET_PRICELIST_TYPE';
export const SET_PRICELIST_TITLE = 'project/SET_PRICELIST_TITLE';
export const SET_USEK_ATTRIBUTE = 'project/SET_USEK_ATTRIBUTE';
export const UPDATE_OPERATION_ITEM = 'project/UPDATE_OPERATION_ITEM';
export const USE_PRICELIST_DATA = 'project/USE_PRICELIST_DATA';
export const USE_PRICELIST_FOR_CALCULATION = 'project/USE_PRICELIST_FOR_CALCULATION';
export const USE_READED_ITEMS = 'project/USE_READED_ITEMS';

export default function getActions(dispatch) {
    return {
        addOperationItem: (opId, title, price) => dispatch({
            type: ADD_OPERATION_ITEM,
            opId, title, price
        }),
        addUsek: (item) => dispatch({
            type: ADD_USEK,
            item
        }),
        clear: () => dispatch({
            type: CLEAR
        }),
        changeUsekId: (id_usek_old, id_usek_new) => dispatch({
            type: CHANGE_USEK_ID,
            id_usek_old, id_usek_new
        }),
        deleteOperationItem: (id) => dispatch({
            type: DELETE_OPERATION_ITEM,
            id
        }),
        deleteUsek: (id_usek) => dispatch({
            type: DELETE_USEK,
            id_usek
        }),
        editUsek: (item) => dispatch({
            type: EDIT_USEK,
            item
        }),
        readPricelist: (content) => dispatch({
            type: READ_PRICELIST,
            content
        }),
        readProject: (content) => dispatch({
            type: READ_PROJECT,
            content
        }),
        readFile: (content, fileName) => dispatch({
            type: READ_FILE,
            content, fileName
        }),
        setCalculationOperation: (usekId, opId, itemId, pricePerUnit) => dispatch({
            type: SET_CALCULATION_OPERATION,
            usekId, opId, itemId, pricePerUnit
        }),
        setErrorMessage: (errorMessage) => dispatch({
            type: SET_ERROR_MESSAGE,
            errorMessage
        }),
        setInputType: (inputType) => dispatch({
            type: SET_INPUT_TYPE,
            inputType
        }),
        setMapContent: (mapContent) => dispatch({
            type: SET_MAP_CONTENT,
            mapContent
        }),
        setPricelistType: (pricelistType) => dispatch({
            type: SET_PRICELIST_TYPE,
            pricelistType
        }),
        setPricelistTitle: (title) => dispatch({
            type: SET_PRICELIST_TITLE,
            title
        }),
        setUsekAttribute: (usekId, name, value) => dispatch({
            type: SET_USEK_ATTRIBUTE,
            usekId, name, value
        }),
        updateOperationItem: (id, title, price) => dispatch({
            type: UPDATE_OPERATION_ITEM,
            id, title, price
        }),
        usePricelistData: (readOnly, data) => dispatch({
            type: USE_PRICELIST_DATA,
            readOnly, data
        }),
        usePricelistForCalculation: () => dispatch({
            type: USE_PRICELIST_FOR_CALCULATION
        }),
        useReadedItems: () => dispatch({
            type: USE_READED_ITEMS
        })
    };
}

function projectOperation(operationName, serverApi, action) {
    const {type, ...params} = action;
    return new Promise((resolve, reject) => {
        serverApi.callPost({
            module: 'calc',
            name: operationName,
            body: {
                params: params
            },
            callback: getPromiseCallback(
                resolve, reject, {
                    responseSelector: ''
                }
            )
        });
    });
}

function* workReadFile(options, action) {
    try {
        yield call(clearActionType);
        yield put({type: CLEAR_READ_FILE});
        yield put({type: PROJECT_ACTION_TYPE.DEFAULT});
        yield put({type: PROJECT_ACTION_TYPE.LOADING});
        const data = yield call(projectOperation, 'readFile', options.serverApi, action);
        yield put({type: PROJECT_ACTION_TYPE.SUCCESS, data});

    } catch (error) {
        yield call(setOperationError, error, PROJECT_ACTION_TYPE);
    }
}

export function* watchReadFile(options) {
    yield takeEvery(READ_FILE, workReadFile, options);
}
